import RecommendationCards from './RecommendationCards';

export default RecommendationCards;
